import React from "react";
import style from "./footer.module.scss";

function Footer() {
  return (
    <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
      <div className="container-fluid d-flex flex-column flex-md-row flex-stack">
        <div className="text-gray-900 order-2 order-md-1">
          <span className="text-muted fw-semibold me-2">2024©</span>
          <a
            className="text-gray-800 text-hover-primary"
            href="https://keenthemes.com"
            target="_blank"
          >
            Aguacatecnia
          </a>
        </div>
        
      </div>
    </div>
  );
}

export default Footer;
